import { GET_SIGNATURE_REQUEST_SUCCESS, SIGN_SIGNATURE_REQUEST_SUCCESS } from './signatureRequest.type';

const initialState = {
    signatureRequest: null,
    signed: false,
};

export const signatureRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SIGNATURE_REQUEST_SUCCESS:
            return {
                ...state,
                signatureRequest: action.payload,
                signed: false,
            };

        case SIGN_SIGNATURE_REQUEST_SUCCESS:
            return {
                ...state,
                signed: true,
            };

        default:
            return state;
    }
};
